export interface Instructor {
  id: number;
  name: string;
  title: string;
  bio: string;
  description: string;
  email: string;
  phone: string;
  address: string;
  image: string;
  socials?: {
    facebook?: string;
    instagram?: string;
    twitter?: string;
    linkedin?: string;
  };
}

const teamData: Instructor[] = [
  {
    id: 1,
    name: "Bedirhan Güven",
    title: "Head of Engineering, Paycell",
    bio: "Yazılım Mühendisi ve Teknoloji Yöneticisi. Paycell’de Head of Engineering olarak görev yapıyor. Daha önce Getir, DFDS ve AktifBank’ta ekipler yönetti.",
    description:
      "Bedirhan Güven, Türkiye ve yurtdışında teknoloji projelerinde liderlik yapmış deneyimli bir yazılım yöneticisidir. 2016-2018’de AktifBank’ta Passo ve NKolay uygulamalarının geliştirme ekibini yönetti. 2018-2021 arasında Danimarka merkezli DFDS’te mobil geliştirme ve Ar-Ge ekiplerini yönetti. 2021-2023 döneminde Getir’de mobil platform ekibini yönetti. 2023 itibarıyla Paycell’de Head of Engineering olarak görevine devam ediyor. Ayrıca 'Yüksek Trafikli Yazılım Mimarisi' ve 'CTO Eğitimi' gibi eğitimlerle teknoloji liderlerine deneyimlerini aktarıyor.",
    email: "info@bedirhanguven.com",
    phone: "+90 555 222 3344",
    address: "Istanbul, Turkey",
    image: require("@/assets/img/all-img/bedirhanguven.png"),
    socials: {
      facebook: "https://facebook.com/bedirhanguven",
      instagram: "https://instagram.com/bedirhanguven",
      twitter: "https://twitter.com/bedirhanguven",
      linkedin: "https://linkedin.com/in/bedirhanguven",
    },
  },
  {
    id: 2,
    name: "Daniel Steven",
    title: "Frontend Developer",
    bio: "10+ yıllık tecrübeye sahip, modern frontend teknolojilerinde uzman.",
    description:
      "Daniel Steven, frontend teknolojilerinde 10 yılı aşkın süredir profesyonel olarak çalışmaktadır. React, Vue ve modern frontend ekosisteminde uzmanlaşmıştır. Çeşitli uluslararası projelerde frontend ekiplerini yönetmiş ve eğitmenlik yapmıştır.",
    email: "daniel@example.com",
    phone: "+90 555 111 2233",
    address: "Istanbul, Turkey",
    image: require("@/assets/img/all-img/team6.png"),
    socials: {
      facebook: "https://facebook.com/danielsteven",
      instagram: "https://instagram.com/danielsteven",
      twitter: "https://twitter.com/danielsteven",
      linkedin: "https://linkedin.com/in/danielsteven",
    },
  },
];

export default teamData;
